import PersonalDetailsFormRegister from './PersonalDetailsFormRegister/PersonalDetailsFormRegister'
import CredentialsForm from './CredentialsForm/CredentialsForm'
import RolsForm from './RolsForm/RolsForm'
import UserTypeForm from './UserTypeForm/UserTypeForm'

export const steps = {
  CredentialsForm,
  PersonalDetailsFormRegister,
  UserTypeForm,
  RolsForm
}
